import { createSlice } from '@reduxjs/toolkit';

import { getDefaultDate } from '../../utils/date';
import { updateGuardrails } from './actions';
import {
  DEFAULT_GUARDRAILS,
  GUARDRAIL_NAME_BY_VALUE,
  GUARDRAILS_SLICE_NAME,
} from './constants';
import type { GuardrailsType } from './types';

const initialState: GuardrailsType = {
  guardrails: { ...DEFAULT_GUARDRAILS },
  updatedAt: '',
  updatedBy: '',
};

const slice = createSlice({
  name: GUARDRAILS_SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(updateGuardrails, (state, action) => {
      for (const { name, enabled } of action.payload.guardrails) {
        const key = GUARDRAIL_NAME_BY_VALUE[name];
        if (key) {
          state.guardrails[key] = { enabled };
        }
      }
      state.updatedAt = getDefaultDate();
    });
  },
});

export default slice.reducer;
